export const stationsFromProductionLines = (state) => {
    return state.productionLines.map(l => l.stations).flat()
}
export const machinesFromProductionLines = (state) => {
    return state.productionLines.map(l => l.stations?l.stations.map(e => e.machines).flat():[] ).flat()
}
export const removeArrayObject = (array, obj) => {
    var index = array.indexOf(obj);
    if(index >= 0){
        array.splice(index, 1)
    }
}
import config from './config'
export const showWarning = (...args) => {
    if(config.showWarnings) console.warn(...args)
}
export const showMessage = (...args) => {
    if(config.showMessages) console.log(...args)
}
